import { render, staticRenderFns } from "./ColView.vue?vue&type=template&id=162a5148&scoped=true&"
import script from "./ColView.vue?vue&type=script&lang=js&"
export * from "./ColView.vue?vue&type=script&lang=js&"
import style0 from "./ColView.vue?vue&type=style&index=0&id=162a5148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a5148",
  null
  
)

export default component.exports